
import Api from "../../lib/Api";
import { UPDATE_POLICY } from "./types";

export const fetchPolicyDetails = (body) => async (dispatch) => {
  try{
    const response = await Api.post(body, '/policy/crm/eligibility');
    if(response.status === 'success'){
      dispatch({
        type: UPDATE_POLICY,
        payload: response.data
      })
    }
  } catch(err){
    console.log(err.message)
  }
}

export const shareCrmLink = (body) => async (dispatch) => {
  try{
    await Api.post(body, '/policy/crm/share');
  } catch(err){
    console.log(err.message)
  }
}